export const getPointIcons = (groupName, groupIds) => {
	const collections = {};
	const dataKeys = Object.keys(global.OC_spriteData);

	dataKeys.forEach((key) => {
		// Check that the image has an object in the sprite json, that the map has the image and that the image is being used for
		// point creation
		if (groupIds.includes(key)) {
			const spriteData = {
				name: key,
				...global.OC_spriteData[key]
			};

			// Initialize the array if it doesn't exist
			if (!collections[groupName]) {
				collections[groupName] = [];
			}

			collections[groupName].push(spriteData);
		}
	});
	return collections;
};
